import React, { FC } from 'react';

import Price from '@components/ui/price';
import { Col } from '@components/formStyles';
import { SFPreferredHotelItemViewModel } from '@api/index';
import { optimizeImage } from '@utils/imageOptimization';
import { PatchedLink } from '@utils/patched-link';
import LazyImage from '@components/Carousel/LazyImage';

import {
  CardWrapper,
  HotelImageWrapper,
  HotelName,
  PriceWrapper,
  HotelInfoOverlay,
  FromText,
  HotelOrderBadge,
  Line,
} from './styled';

const PreferredHotelCard: FC<{
  hotel: SFPreferredHotelItemViewModel;
  index?: number;
}> = ({ hotel, index }) => {
  return (
    <PatchedLink href={hotel?.url || '#'}>
      <CardWrapper>
        <HotelImageWrapper>
          <HotelOrderBadge>{(index ?? 0) + 1}</HotelOrderBadge>
          <LazyImage
            src={optimizeImage(
              hotel?.image?.url || '/static/images/placeholder-image.webp',
              '400',
              '500'
            )}
            alt={hotel?.image?.alt || 'Otel'}
            width={400}
            height={500}
            style={{ objectFit: 'cover', alignItems: 'center' }}
            className='preferredHotelCard__image'
          />
          <HotelInfoOverlay>
            <HotelName>{hotel.name}</HotelName>
            <Line />
            <PriceWrapper>
              {hotel.price && (
                <Col>
                  <Price color='white' price={hotel.price} />
                  <FromText>'den itibaren</FromText>
                </Col>
              )}
            </PriceWrapper>
          </HotelInfoOverlay>
        </HotelImageWrapper>
      </CardWrapper>
    </PatchedLink>
  );
};

export default PreferredHotelCard;
